@if (tourAnchorId) {
    <a
        (click)="onClick.emit($event)"
        #rla="routerLinkActive"
        [activated]="rla.isActive"
        mat-list-item
        [routerLink]="routerLink"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact }"
        [attr.data-testid]="testId || null"
        [tourAnchor]="tourAnchorId"
        style="cursor: pointer"
    >
        <app-icon [icon]="icon"></app-icon>
    </a>
} @else {
    <a
        (click)="onClick.emit($event)"
        #rla="routerLinkActive"
        [activated]="rla.isActive"
        mat-list-item
        [routerLink]="routerLink"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact }"
        [attr.data-testid]="testId || null"
        style="cursor: pointer"
    >
        <app-icon [icon]="icon"></app-icon>
    </a>
}
